import type { ReferenceTier } from '@/lib/apollo/query/get-applicant'

export const isRestrictedReference = (referenceTier?: ReferenceTier): boolean => {
  return referenceTier === undefined
}
